<template>
    <div>
        <search-panel :active-link="activeLink" />
        <nuxt-child />
    </div>
</template>

<script>
// child components
import SearchPanel from '~/components/pages/home/search-panel';
// mixins
import removeCookie from '~/scripts/mixins/removeCookie';

const imagePreload = href => ({
    type: 'image/jpeg',
    as: 'image',
    rel: 'prefetch',
    href,
    crossorigin: true,
});

export default {
    name: 'HomePage',
    components: {
        SearchPanel,
    },
    mixins: [removeCookie],
    data () {
        return {
            canonical: {},
        };
    },
    computed: {
        activeLink () {
            const routes = {
                'tour': 'tour',
                'iranout': 'international',
                'train-ticket': 'train',
                'bus-ticket': 'bus',
                'hotel': 'hotel',
            };
            for (const key in routes) {
                if (new RegExp('^/' + key).test(this.$route.path || '')) {
                    return routes[key];
                }
            }
            return 'domestic';
        },
    },
    asyncData ({ req, route }) {
        // only do this on server-side requests
        if (process.server && route.path === '/') {
            // get hostname from request headers
            const { host } = req.headers;
            // don't add canonical on .aero
            const isAero = host.includes('.aero');
            if (!isAero) {
                return {
                    canonical: { rel: 'canonical', href: 'https://www.alibaba.ir' },
                };
            }
        }
        return {
            canonical: {},
        };
    },
    head () {
        return {
            title: 'بلیط هواپیما - خرید اینترنتی بلیط هواپیما | علی بابا',
            link: (!this.$device.mobile ? [
                '/images/hero/train-bg.jpg',
                '/images/hero/bus-bg.jpg',
                '/images/hero/flight-bg.jpg',
                '/images/hero/hotel-bg.jpg',
                '/images/hero/tour-bg.jpg',
            ].map(imagePreload) : []).concat([
                this.canonical,
            ]),
        };
    },

    mounted () {
        this._removeAllStorages();
    },
};
</script>

<style lang="scss" >
@import 'owl.carousel/dist/assets/owl.carousel.css';
@import 'owl.carousel/dist/assets/owl.theme.default.css';
@import '~vars';
@import 'assets/styles/mixins/transition';

.block-info-section {
    margin-top: 0;
    padding-top: 0;
    text-align: center;

    &__title {
        font-size: 2em;
        margin-top: 0;
    }

    &__caption {
        font-size: 1.2em;
        color: $gray;
    }
}

.carousel-alibaba-style {
    overflow: hidden;

    .item {
        border-radius: 3px;
        float: right;
        text-align: center;
    }

    .owl-dots {
        margin-top: 10px;
        width: 100%;
        text-align: center;
    }

    .owl-dot {
        width: 8px;
        height: 8px;
        border-radius: 100%;
        border: 1px solid $hotel-border-gray !important;
        background: $gray-light;
        margin-right: 5px;
        display: inline-block; /* for making them horizontal, if you want vertical then you can use- display: block */
    }

    .owl-dot.active {
        background: $orange;
    }

    .owl-item {
        text-align: right;
    }
}
//Mobile Device

body.mobile {

    .block-info-section__title {
        font-size: 1.5em;
    }

    .block-info-section__caption {
        font-size: 1em;
    }
}
</style>
